<template>
    <CodiceFeanorView tool-module="hash" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
